const scrollProgressMain = () => {
	if (document.querySelector(".scroll-progress")) {
		return;
	}
	const container = document.querySelector(".wp-site-blocks");

	const track = document.createElement("div");
	track.classList.add("scroll-progress-track");
	document.body.appendChild(track);

	const progressBar = document.createElement("div");
	progressBar.classList.add("scroll-progress");
	document.body.appendChild(progressBar);


	const getScrollData = () => {
		if (container && container.scrollHeight > container.clientHeight) {
			return {
				scrollTop: container.scrollTop,
				documentHeight: container.scrollHeight - container.clientHeight,
				target: container,
			};
		}

		return {
			scrollTop: window.scrollY,
			documentHeight: document.documentElement.scrollHeight - window.innerHeight,
			target: window,
		};
	};

	const updateProgress = () => {
		const { scrollTop, documentHeight } = getScrollData();

		if (documentHeight <= 0) {
			progressBar.style.transform = "scaleY(0)";
			return;
		}

		const progress = scrollTop / documentHeight;

		progressBar.style.transform = `scaleY(${progress})`;
	};

	const { target } = getScrollData();

	updateProgress();

	target.addEventListener("scroll", updateProgress);

	window.addEventListener("resize", updateProgress);
};

export { scrollProgressMain };
